<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      @onGroupDelete="groupDelete"
    >
      <template #leftHeader="{ selectList }">
        <b-button
          v-if="selectList.length"
          variant="outline-danger"
          @click="groupDelete"
        >
          {{ $t("general.groupDelete") }} {{ selectList.length ? `(${selectList.length})` : "" }}
        </b-button>
        <b-button
          v-if="selectList.length"
          variant="outline-info"
          @click="() => groupArchive(selectList)"
        >
          {{ $t("suggestions.archive") }} {{ $t("general.group") }} {{ selectList.length ? `(${selectList.length})` : "" }}
        </b-button>

      </template>
      <!-- Column: Archive -->
      <template #cell(archive)="{ item }">
        <b-form-checkbox
          :checked="item.archive"
          class="mt-1"
          switch
          inline
          @change="(val) => toggleArchive(item._id, val)"
        />
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <view-row @click.native="$router.push({name: `pages-feedback-edit`,params: { id: item._id } })" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import { BButton, BFormCheckbox } from 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import ViewRow from '@/components/BDataTable/Actions/ViewRow.vue'
import useFeedbackList from './useFeedbackList'

export default {
  name: 'FeedbackList',
  components: {
    BButton,
    BDataTable,
    BFormCheckbox,
    LayoutLoading,
    ViewRow,
  },
  setup() {
    const {
      deleteItem,
      fetchList,
      groupArchive,
      groupDelete,
      refTable,
      tableColumns,
      toEditPage,
      isSubmit,
      toggleArchive,
    } = useFeedbackList()
    return {
      deleteItem,
      fetchList,
      groupArchive,
      groupDelete,
      refTable,
      tableColumns,
      isSubmit,
      toEditPage,
      toggleArchive,
    }
  },
}
</script>
